import React from 'react';
import {Link} from 'react-router-dom';

import './Page404.sass';
import NotFoundImage from '../../images/pic_404.png';

const page404 = ({isBackBtn = true, isRefreshAvailable = false}) => {
    var refreshPage = () => {
        window.location.reload(); 
    };
    return (
        <div className="not-found">
            <h2>Sorry, page is not found</h2>
            <img src={NotFoundImage} alt="not found"/>
            {isBackBtn && (
              <Link to="/">
                  <button className="btn-primary">Back to main</button>
              </Link>
            )}
            {isRefreshAvailable && (
                <button className="btn-primary" onClick={refreshPage}>Refresh</button>
            )}
        </div>
    );
};

export default page404;
